module.exports = __webpack_public_path__ + "static/ui2-146d4cf8e232b036bbda301303958243.mp3";